import { makeStyles } from "@mui/styles";
import { primary_gradient_reverse } from "../../themes/colors";

const useStyles = makeStyles({
  backdrop: {
    zIndex: 10,
    color: "#fff",
    overflow: "auto",
    paddingBottom: "100px",
    paddingLeft: 10,
  },
  card: { width: "600px", marginTop: "100px" },
  card_header: {
    backgroundImage: primary_gradient_reverse,
    color: "white",
    fontWeight: "bold",
    fontSize: "15px",
    padding: "10px",
  },
  text_field: { width: "100%" },
  button_row: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-end",
  },
  switch: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  info_text: {
    color: "#a3a3a3",
    fontSize: "10px",
    padding: "5px",
  },
});

export default useStyles;
